import React from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Download, Instagram } from 'lucide-react';
import { 
  WelcomeTemplate, 
  CandidateTemplate, 
  CompanyTemplate,
  StatisticsTemplate,
  TutorialSlide1,
  TutorialSlide2,
  TutorialSlide3,
  SectorsTemplate,
  CareerTipsTemplate,
  CTATemplate,
  CommunityTemplate
} from '@/components/InstagramTemplates';

export default function InstagramTemplatesPage() {
  const downloadAsPNG = (elementId, filename) => {
    const svgElement = document.getElementById(elementId).querySelector('svg');
    const svgData = new XMLSerializer().serializeToString(svgElement);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    
    canvas.width = 1080;
    canvas.height = 1080;
    
    const img = new Image();
    const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svgBlob);
    
    img.onload = () => {
      ctx.drawImage(img, 0, 0, 1080, 1080);
      canvas.toBlob((blob) => {
        const link = document.createElement('a');
        link.download = filename;
        link.href = URL.createObjectURL(blob);
        link.click();
        URL.revokeObjectURL(url);
      }, 'image/png', 1.0);
    };
    
    img.src = url;
  };

  const templates = [
    {
      id: 'post-1-welcome',
      title: 'Post 1: Bem-Vindos',
      description: 'Post de lançamento da plataforma',
      component: <WelcomeTemplate />,
      filename: 'trabadju_post_1_welcome.png',
      caption: `🚀 Chegamos para revolucionar o mercado de emprego em Cabo Verde! 🇨🇻

O Trabadju é a plataforma que conecta empresas e talentos de forma simples, rápida e gratuita.

✨ Para Candidatos:
• Perfil completo com CV
• Procura de vagas em tempo real
• Candidatura com 1 clique

✨ Para Empresas:
• Publique vagas facilmente
• Acesso a talentos qualificados
• Planos a partir de 500 CVE/mês

👉 Visite trabadju.cv
📧 info@trabadju.cv

#Trabadju #EmpregoCV #CaboVerde #Emprego #Trabalho #Vagas #Recrutamento #PraiaCaboVerde #Mindelo #SaoVicente #Santiago`
    },
    {
      id: 'post-2-candidatos',
      title: 'Post 2: Para Candidatos',
      description: 'Benefícios para quem procura emprego',
      component: <CandidateTemplate />,
      filename: 'trabadju_post_2_candidatos.png',
      caption: `💼 Procura emprego em Cabo Verde?

No Trabadju, encontrar a vaga ideal é simples:

✅ Registo GRATUITO
✅ Crie o seu perfil completo
✅ Upload de CV e documentos
✅ Procure vagas por categoria
✅ Candidate-se com 1 clique

🎯 Áreas disponíveis:
• Tecnologia
• Turismo
• Vendas
• Administrativo
• E muito mais!

Comece hoje 👉 trabadju.cv
📧 info@trabadju.cv

#ProcuroEmprego #VagasCV #CaboVerde #CarreiraCV #OportunidadesCV`
    },
    {
      id: 'post-3-empresas',
      title: 'Post 3: Para Empresas',
      description: 'Planos de patrocínio',
      component: <CompanyTemplate />,
      filename: 'trabadju_post_3_empresas.png',
      caption: `🏢 É empresário em Cabo Verde?

Encontre os melhores talentos na Trabadju!

💡 Planos para todos os tamanhos:

📌 BÁSICO - GRÁTIS
• 1 vaga por 30 dias
• Depois apenas 500 CVE/mês

📌 STANDARD - 2.500 CVE
• Até 5 vagas ativas
• Visibilidade aumentada
• Badge "Verificado"

📌 UNLIMITED - 6.000 CVE
• Vagas ilimitadas
• Máxima visibilidade
• Gestor de conta dedicado

Publique a sua primeira vaga hoje!
👉 trabadju.cv
📧 info@trabadju.cv

#RecrutamentoCV #EmpresasCV #RHCaboVerde #RecursosHumanos`
    },
    {
      id: 'post-4-estatisticas',
      title: 'Post 4: Estatísticas',
      description: 'Dados sobre o mercado de emprego',
      component: <StatisticsTemplate />,
      filename: 'trabadju_post_4_estatisticas.png',
      caption: `📈 Sabias que...

🔸 70% dos cabo-verdianos procuram emprego online
🔸 3 em cada 4 empresas têm dificuldade em encontrar talentos
🔸 O Trabadju resolve isso! 🚀

Plataforma 100% cabo-verdiana, feita para o nosso mercado.

👉 trabadju.cv
📧 info@trabadju.cv

#DadosCV #MercadoDeTrabalhoCV #EstatísticasCV #CaboVerde`
    },
    {
      id: 'post-5-slide-1',
      title: 'Post 5: Tutorial Slide 1',
      description: 'Carrossel: Passo 1 - Registe-se',
      component: <TutorialSlide1 />,
      filename: 'trabadju_post_5_tutorial_slide_1.png',
      caption: `📲 Tutorial: Como candidatar-se a uma vaga

É mais fácil do que pensa! Siga estes 3 passos:

1️⃣ Registe-se gratuitamente em trabadju.cv
2️⃣ Complete o seu perfil (CV, carta de motivação)
3️⃣ Procure vagas e candidate-se com 1 clique!

Simples, rápido e eficaz! 💪

👉 Deslize para ver todos os passos →
📧 info@trabadju.cv

#TutorialTrabadju #ComoUsarTrabadju #GuiaDeEmprego #CaboVerde`
    },
    {
      id: 'post-5-slide-2',
      title: 'Post 5: Tutorial Slide 2',
      description: 'Carrossel: Passo 2 - Complete o Perfil',
      component: <TutorialSlide2 />,
      filename: 'trabadju_post_5_tutorial_slide_2.png',
      caption: ''
    },
    {
      id: 'post-5-slide-3',
      title: 'Post 5: Tutorial Slide 3',
      description: 'Carrossel: Passo 3 - Candidate-se',
      component: <TutorialSlide3 />,
      filename: 'trabadju_post_5_tutorial_slide_3.png',
      caption: ''
    },
    {
      id: 'post-6-setores',
      title: 'Post 6: Setores',
      description: 'Áreas de vagas disponíveis',
      component: <SectorsTemplate />,
      filename: 'trabadju_post_6_setores.png',
      caption: `🎯 Vagas em TODAS as áreas!

No Trabadju encontra oportunidades em:

💻 Tecnologia & IT
🏨 Turismo & Hotelaria
🏪 Comércio & Vendas
🏦 Banca & Finanças
🏗️ Construção Civil
📚 Educação
🏥 Saúde
📱 Marketing & Comunicação

Qual é a sua área? Comente abaixo! 👇

👉 trabadju.cv
📧 info@trabadju.cv

#SetoresCV #ÁreasDeTrabalhoCaboVerde #DiversidadeDeVagas`
    },
    {
      id: 'post-7-dicas',
      title: 'Post 7: Dicas de Carreira',
      description: 'Dica sobre CV profissional',
      component: <CareerTipsTemplate />,
      filename: 'trabadju_post_7_dicas.png',
      caption: `💡 Dica de Carreira #1

"Um CV bem estruturado aumenta em 60% as suas chances de ser chamado para entrevista!"

✅ Dicas para um CV perfeito:
• Informações claras e objetivas
• Experiências relevantes
• Competências destacadas
• Foto profissional
• Sem erros ortográficos

📄 No Trabadju, carregue o seu CV e destaque-se!

👉 trabadju.cv
📧 info@trabadju.cv

#DicasDeCarreira #CVCV #DicasDeTrabadju #CarreiraCV`
    },
    {
      id: 'post-8-cta',
      title: 'Post 8: Call to Action',
      description: 'Chamada urgente para empresas',
      component: <CTATemplate />,
      filename: 'trabadju_post_8_cta.png',
      caption: `📣 ATENÇÃO EMPRESAS!

Está a recrutar? Publique GRÁTIS a sua primeira vaga!

🎁 Oferta de lançamento:
✨ 30 dias GRÁTIS no plano Básico
✨ Sem cartão de crédito
✨ Sem compromisso

Depois, apenas 500 CVE/mês para continuar a publicar!

🚀 Comece agora: trabadju.cv
📧 info@trabadju.cv

#ContratarCV #RecrutamentoGrátis #OfertaTrabadju #EmpresasCV`
    },
    {
      id: 'post-9-comunidade',
      title: 'Post 9: Comunidade',
      description: 'Orgulho cabo-verdiano',
      component: <CommunityTemplate />,
      filename: 'trabadju_post_9_comunidade.png',
      caption: `🇨🇻 Feito em Cabo Verde, para Cabo Verde!

O Trabadju é mais que uma plataforma de emprego.
É uma comunidade que acredita no potencial cabo-verdiano! 💪

🌟 Nossa missão:
Conectar cada talento à oportunidade certa.
Ajudar empresas locais a crescer.
Fortalecer a economia de Cabo Verde.

🙌 Partilhe com alguém que procura emprego!

👉 trabadju.cv
📧 info@trabadju.cv

#CaboVerde #OrgulhoCaboVerdiano #FeitoEmCV #ComunidadeTrabadju`
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-12 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Instagram className="h-12 w-12 text-pink-600" />
            <h1 className="text-5xl font-bold bg-gradient-to-r from-pink-600 via-purple-600 to-blue-600 bg-clip-text text-transparent">
              Instagram Templates
            </h1>
          </div>
          <p className="text-xl text-gray-600 mb-2">
            Templates profissionais prontos para publicar
          </p>
          <p className="text-sm text-gray-500">
            Formato: 1080x1080px (Post Instagram) • Alta Qualidade PNG
          </p>
        </div>

        {/* Templates Grid */}
        <div className="space-y-12">
          {templates.map((template) => (
            <Card key={template.id} className="p-8 bg-white shadow-lg">
              <div className="grid md:grid-cols-2 gap-8">
                {/* Preview */}
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">
                    {template.title}
                  </h3>
                  <p className="text-gray-600 mb-4">{template.description}</p>
                  
                  <div 
                    id={template.id}
                    className="bg-gray-100 rounded-lg overflow-hidden shadow-xl border-2 border-gray-200"
                    style={{ maxWidth: '100%', aspectRatio: '1/1' }}
                  >
                    {template.component}
                  </div>
                  
                  <Button
                    onClick={() => downloadAsPNG(template.id, template.filename)}
                    className="w-full mt-4 bg-gradient-to-r from-pink-600 via-purple-600 to-blue-600 hover:from-pink-700 hover:via-purple-700 hover:to-blue-700 text-white"
                    size="lg"
                  >
                    <Download className="h-5 w-5 mr-2" />
                    Descarregar PNG (1080x1080)
                  </Button>
                </div>

                {/* Caption */}
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-3 flex items-center gap-2">
                    <Instagram className="h-5 w-5 text-pink-600" />
                    Legenda Sugerida
                  </h4>
                  <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                    <pre className="text-sm text-gray-700 whitespace-pre-wrap font-sans leading-relaxed">
                      {template.caption}
                    </pre>
                  </div>
                  
                  <Button
                    onClick={() => {
                      navigator.clipboard.writeText(template.caption);
                      alert('Legenda copiada para clipboard! ✅');
                    }}
                    variant="outline"
                    className="w-full mt-4"
                  >
                    📋 Copiar Legenda
                  </Button>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Guide */}
        <Card className="p-8 mt-12 bg-gradient-to-r from-blue-50 to-purple-50 border-blue-200">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            📱 Como Usar os Templates
          </h3>
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <h4 className="font-semibold text-gray-900 mb-3">1️⃣ Descarregar</h4>
              <ul className="space-y-2 text-sm text-gray-700">
                <li>✅ Clique em "Descarregar PNG" em cada template</li>
                <li>✅ Ficheiro salva automaticamente no seu dispositivo</li>
                <li>✅ Formato: 1080x1080px (ideal para Instagram)</li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold text-gray-900 mb-3">2️⃣ Publicar</h4>
              <ul className="space-y-2 text-sm text-gray-700">
                <li>✅ Abra o Instagram no telemóvel</li>
                <li>✅ Clique em "+" para nova publicação</li>
                <li>✅ Selecione a imagem descarregada</li>
                <li>✅ Copie e cole a legenda sugerida</li>
                <li>✅ Adicione hashtags e publique! 🚀</li>
              </ul>
            </div>
          </div>
          
          <div className="mt-6 p-4 bg-white rounded-lg">
            <h4 className="font-semibold text-gray-900 mb-2">💡 Dica Profissional</h4>
            <p className="text-sm text-gray-700">
              Publique 3-4 posts por semana, sempre nos horários de maior engagement (12h-14h e 19h-21h em Cabo Verde). 
              Use as hashtags sugeridas e responda aos comentários nas primeiras 2 horas para aumentar o alcance! 📈
            </p>
          </div>
        </Card>

        {/* Calendar Guide */}
        <Card className="p-8 mt-12 bg-gradient-to-r from-green-50 to-blue-50 border-green-200">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            📅 Calendário de Publicação Sugerido
          </h3>
          <div className="grid md:grid-cols-3 gap-6">
            <div>
              <h4 className="font-semibold text-gray-900 mb-3">Semana 1</h4>
              <ul className="space-y-2 text-sm text-gray-700">
                <li>✅ Post 1: Bem-Vindos</li>
                <li>✅ Post 2: Para Candidatos</li>
                <li>✅ Post 3: Para Empresas</li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold text-gray-900 mb-3">Semana 2</h4>
              <ul className="space-y-2 text-sm text-gray-700">
                <li>• Post 4: Estatísticas</li>
                <li>• Post 5: Tutorial (3 slides)</li>
                <li>• Post 6: Setores</li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-gray-900 mb-3">Semana 3</h4>
              <ul className="space-y-2 text-sm text-gray-700">
                <li>• Post 7: Dicas de Carreira</li>
                <li>• Post 8: Call to Action</li>
                <li>• Post 9: Comunidade</li>
              </ul>
            </div>
          </div>
          
          <div className="mt-6 p-4 bg-white rounded-lg">
            <h4 className="font-semibold text-gray-900 mb-2">💡 Dica Extra</h4>
            <p className="text-sm text-gray-700">
              Após publicar os 9 posts, continue com conteúdo como: Vagas da Semana, Histórias de Sucesso, 
              Dicas de Entrevista, Testemunhos de Empresas, etc. Mantenha 3-4 posts por semana! 📈
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
}
